import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-perugia',
  templateUrl: './sessione-perugia.component.html',
  styleUrls: ['./sessione-perugia.component.css']
})
export class SessionePerugiaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
